const normalizeTextarea = (value: any) => {
    if (!value) {
      return value;
    }
    const onlyText = value.trimStart();
    if (onlyText) {
      return value;
    }
   
  };
  
  export default normalizeTextarea;